import Yup from '_zari/validation/_yup'

import { TiposDocumentoSunatConstant } from 'constants/index'

export const ValidationSchema = Yup.object().shape({
  condicionPago: Yup.string().required(),
  moneda: Yup.string().required(),
  tipoDocumento: Yup.string().required(),
  fechaEmision: Yup.string().required(),
  fechaVencimiento: Yup.string().required(),
  tipoNota: Yup.string().when('tipoDocumento', {
    is: TiposDocumentoSunatConstant.NOTA_CREDITO,
    then: Yup.string().required()
  }),
  motivo: Yup.string().when('tipoDocumento', {
    is: TiposDocumentoSunatConstant.NOTA_CREDITO,
    then: Yup.string().required()
  })
})
